const BASE = process.env.REACT_APP_BACKEND_URL;

async function jsonFetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.detail || data?.message || `Request failed (${res.status})`;
    throw new Error(typeof msg === "string" ? msg : "Request failed");
  }
  return data;
}

export const api = {
  subscribeNewsletter: (payload) =>
    jsonFetch("/api/newsletter/subscribe", { method: "POST", body: JSON.stringify(payload) }),
  submitContact: (payload) =>
    jsonFetch("/api/contact", { method: "POST", body: JSON.stringify(payload) }),
  createDonationCheckout: (payload) =>
    jsonFetch("/api/donations/checkout", { method: "POST", body: JSON.stringify(payload) }),
  getDonationStatus: (sessionId) =>
    jsonFetch(`/api/donations/status/${encodeURIComponent(sessionId)}`),
};
